module.exports = __webpack_public_path__ + "img/logo-vertical.b1e93f4e.svg";